// extracted by mini-css-extract-plugin
module.exports = {"clipsPlayPauseButton":"ClipsPlayPauseButton_clipsPlayPauseButton__opjcg","clipsPlayPauseButtonDisabled":"ClipsPlayPauseButton_clipsPlayPauseButtonDisabled__eH69Z"};